import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-569fc22a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = {
  class: "inline-flex",
  href: "https://app.blueshift.fi",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_4 = {
  key: 0,
  class: "title ml-s2 text-gray"
}

import { onMounted, onBeforeUnmount, ref } from 'vue';
import LogoFull from '@/components/LogoFull.vue';
import Wallet from '@/views/wallet/Wallet.vue';
import { useLayout } from '@/composables/core/useLayout';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isDesktop } = useLayout();
const headerRef = ref();
let scrollListener;
const bindScrollListener = () => {
  if (!scrollListener) {
    if (headerRef.value) {
      scrollListener = () => {
        if (window.scrollY > 0) headerRef.value.classList.add('header-sticky');
        else headerRef.value.classList.remove('header-sticky');
      };
    }
  }
  window.addEventListener('scroll', scrollListener);
};
const unbindScrollListener = () => {
  if (scrollListener) {
    window.removeEventListener('scroll', scrollListener);
    scrollListener = null;
  }
};

onMounted(() => bindScrollListener());
onBeforeUnmount(() => unbindScrollListener());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    ref_key: "headerRef",
    ref: headerRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createVNode(LogoFull)
        ]),
        (_unref(isDesktop))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Vesting App"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(Wallet)
    ])
  ], 512))
}
}

})